import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './core/core.module';
import { FormsModule } from '@angular/forms';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { UnsavedChangesGuard, UnsavedChangesService } from './core/routing/auth.guard';

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        // Core Module
        CoreModule,

        // Angular
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        NgxWebstorageModule.forRoot(),

        // Routing
        AppRoutingModule,
    ],
    providers: [
        UnsavedChangesGuard,
        UnsavedChangesService,
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { panelClass: 'mat-dialog-override', hasBackdrop: true, } }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
